// extracted by mini-css-extract-plugin
export default {"infiniteLoader":"infiniteLoader--uvUMu","loading":"loading--YOnk3","loader":"loader--nEUls"};